import PropTypes from 'prop-types';

import { LabelField } from '.';

import { call, formatPhone } from '../../../utils/formatPhone';

const PhoneField = ({ phoneNumber, isResource, id, label }) => {
  const href = !isResource ? `tel:${call(phoneNumber)}` : null;
  let formattedPhoneNumber;
  if (phoneNumber) {
    formattedPhoneNumber = formatPhone(phoneNumber);
  }

  if (!phoneNumber) {
    return;
  }

  return <LabelField id={id} label={label} data={formattedPhoneNumber} href={href} noWrap />;
};
PhoneField.propTypes = {
  isResource: PropTypes.bool,
  phoneNumber: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string
};

export default PhoneField;
